import { cycleCountLineIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const setCycleCountLineCount = unaryRpc({
  name: "setCycleCountLineCount" as const,
  input: z.object({
    lineId: cycleCountLineIdFormat.schema,
    finalCount: z.int().min(0).nullable(),
  }),
  output: z.object({}),
});
